import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function bgParallax() {
  window.addEventListener("scroll", () => {
    gsap.set(".wrap .bg-image", { backgroundPositionY: window.scrollY / 2 });
  });
}
